// Reveal type configuration: colors, labels, big text
export const REVEAL_TYPES = [
  { key: "baby", name: "Baby Gender", desc: "Boy or girl — the sweetest surprise." },
  { key: "exam", name: "Exam / Results", desc: "Pass, fail, grades or qualification news." },
  { key: "custom", name: "Custom Reveal", desc: "Any secret you want to unveil." },
];

export const BABY_OPTIONS = [
  { value: "boy", label: "It's a Boy!", color: "#3B82F6" },
  { value: "girl", label: "It's a Girl!", color: "#EC4899" },
];

export const EXAM_OPTIONS = [
  { value: "pass", label: "PASSED!", color: "#22C55E" },
  { value: "fail", label: "Not this time", color: "#EAB308" },
];

// Returns { headline, color, emoji-free label }
export function resolveReveal(event) {
  const type = event.reveal_type;
  const val = (event.reveal_value || "").toLowerCase();
  if (type === "baby") {
    if (val === "boy") return { headline: "IT'S A BOY!", color: "#3B82F6" };
    if (val === "girl") return { headline: "IT'S A GIRL!", color: "#EC4899" };
  }
  if (type === "exam") {
    if (val === "pass") return { headline: "PASSED!", color: "#22C55E" };
    if (val === "fail") return { headline: event.reveal_label || "KEEP GOING", color: "#EAB308" };
  }
  return { headline: event.reveal_value || event.reveal_label || "REVEALED", color: event.reveal_color || "#D4AF37" };
}
